import styled from 'styled-components';
import colors from '../../../../../../../constants/colors';

export default function ProbSevRiskLines(props) {
  const {
    level,
    size = 16,
  } = props;

  return (
    <Container size={size}>
      <Line color={level >= 0 ? colors.probSevRisk[level] : colors.grey400}>|</Line>
      <Line color={level >= 1 ? colors.probSevRisk[level] : colors.grey400}>|</Line>
      <Line color={level >= 2 ? colors.probSevRisk[level] : colors.grey400}>|</Line>
      <Line color={level >= 3 ? colors.probSevRisk[level] : colors.grey400}>|</Line>
    </Container>
  );
}

const Container = styled.b`
  color: ${colors.grey400};
  font-size: ${(props) => props.size}px;
`;

const Line = styled.span`
  color: ${(props) => props.color || colors.grey400};
  letter-spacing: 1px;
`;
